import React from 'react';
import styled from '@emotion/styled';

const InputContainer = styled.div`
  display: flex;
  margin-bottom: 15px;
  width: ${(props) => props.widthPercentage};
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

const Checkbox = styled.input`
  margin-left: 10px;

  @media (max-width: 600px) {
    flex-basis: 100%;
    margin-left: 0;
  }
`;

const CheckboxWithLabel = ({ label, ...checkboxProps }) => {
  return (
    <InputContainer>
      <Label>{label}</Label>
      <Checkbox type="checkbox" {...checkboxProps} />
    </InputContainer>
  );
};

export default CheckboxWithLabel;
